export const defaultLocales = navigator.languages ? navigator.languages : [navigator.language]
export const fallbackLocale = "en-US"

const numberFormats = {}

export function numberFormat(locale) {
  let format = numberFormats[locale]
  if (!format) {
    format = discoverNumberFormat(locale)
    if (!format) {
      format = numberFormat(fallbackLocale)
    }
  }

  numberFormats[locale] = format

  return format
}

function discoverNumberFormat(locale) {
  const formatted = Intl.NumberFormat(locale).format(1111.1)
  if (formatted.length !== 7) {
    return undefined
  }

  const grouping = formatted.charAt(1)
  const decimal = formatted.charAt(5)

  return {
    grouping,
    decimal,
    locale,
    cleanPattern: new RegExp(`[^0-9${decimal}+-]`, "g"),
  }
}



// WEBPACK FOOTER //
// ../ui-kit/src/lib/locale.js